import {
    SAVE_CANVAS_SETTINGS,
    UPDATE_CANVAS_DATA_PARAM,
} from './types/canvas-action-types';
import { canvasFormStateSelector } from '../selectors/canvas-selectors';

export function updateCanvasDataParams( updatedParam ){
    return {
        type: UPDATE_CANVAS_DATA_PARAM,
        updatedParam,
    };
}

export function saveCanvasSettings( canvasId ){
    return ( dispatch, getState ) => {
        const updatedParams = canvasFormStateSelector( getState() );

        dispatch( {
            canvasId,
            type: SAVE_CANVAS_SETTINGS,
            updatedParams
        } );
    };
}
